module.exports = __webpack_public_path__ + "img/name-3.6f6bc2ac.png";